module.exports = __webpack_public_path__ + "static/img/icon_telegram.285a5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channelServices/icon_telegram.png
// module id = 6ysI
// module chunks = 0